import { render, staticRenderFns } from "./CommonWarehouseList.vue?vue&type=template&id=3e60e8e2&scoped=true&"
import script from "./CommonWarehouseList.vue?vue&type=script&lang=js&"
export * from "./CommonWarehouseList.vue?vue&type=script&lang=js&"
import style0 from "./CommonWarehouseList.vue?vue&type=style&index=0&id=3e60e8e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e60e8e2",
  null
  
)

export default component.exports